import { render, staticRenderFns } from "./TableCellLiteResources.vue?vue&type=template&id=a1a21746&scoped=true"
import script from "./TableCellLiteResources.vue?vue&type=script&lang=js"
export * from "./TableCellLiteResources.vue?vue&type=script&lang=js"
import style0 from "./TableCellLiteResources.vue?vue&type=style&index=0&id=a1a21746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a21746",
  null
  
)

export default component.exports